export default {
  schedule: 'Schedule Meeting',
  prompt: 'Please authorize RingCentral to access your account information.',
  saveAsDefault: 'Save as default',
  launchMeeting: 'Launch Meeting',
} as const;
